import { render } from "./Producer.vue?vue&type=template&id=0d04e3a0"
import script from "./Producer.vue?vue&type=script&lang=js"
export * from "./Producer.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__